import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { IPageMetadata } from '../type-routes/type-route.models.js';
import { unescape } from 'querystring';

@Component({
    templateUrl: './insufficient-permissions.component.html',
    selector: 'mod-insufficient-permissions',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InsufficientPermissionsComponent extends CoreAppComponent implements OnInit {
	public readonly pageMetadata: IPageMetadata = {
		title: 'Insufficient permissions'
	};

	constructor() {
		super();
	}

	ngOnInit(): void {
		super.subscribeToObservable(
			from(
				this.dependencies.logService.logErrorAsync({
					message: `Insufficient permission for user '${this.authUser()?.email}' and url '${
						window.location.pathname
					}'`,
					email: this.authUser()?.email,
					stacktrace: undefined,
					behavior: undefined
				})
			)
		);
	}
}
